module.exports = __webpack_public_path__ + "img/1378010706.911cc45f.jpg";